var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inlineStar"},_vm._l((_vm.starList),function(v,index){return _c('img',{key:'rate' + index,attrs:{"src":_vm.chooseImg(v),"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }